module.exports = __webpack_public_path__ + "img/Mark_Kay_2017.14266968.png";